import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { JobDepartment } from 'server/shared/models/job';

@Component({
  selector: 'app-job-list-item-organisation-heading',
  templateUrl: './job-list-item-organisation-heading.component.html',
  styleUrls: ['./job-list-item-organisation-heading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobListItemOrganisationHeadingComponent {
  department$ = new BehaviorSubject<JobDepartment | undefined>(undefined);
  @Input() set department(value: JobDepartment | undefined) {
    this.department$.next(value);
  }
  get department() {
    return this.department$.value;
  }

  organisation$ = new BehaviorSubject<{ id: string; name: string } | undefined>(
    undefined,
  );
  @Input() set organisation(value: { id: string; name: string } | undefined) {
    this.organisation$.next(value);
  }
  get organisation() {
    return this.organisation$.value;
  }

  jobType$ = new BehaviorSubject<'job-request' | 'job-series' | 'job'>('job');
  @Input() set jobType(value: 'job-request' | 'job-series' | 'job') {
    this.jobType$.next(value);
  }
  get jobType() {
    return this.jobType$.value;
  }

  departmentOnly$ = new BehaviorSubject<boolean>(false);
  @Input() set departmentOnly(value: boolean) {
    this.departmentOnly$.next(value);
  }
  get departmentOnly() {
    return this.departmentOnly$.value;
  }

  compact$ = new BehaviorSubject<boolean>(false);
  @Input() set compact(value: boolean) {
    this.compact$.next(value);
  }
  get compact() {
    return this.compact$.value;
  }

  icon$ = this.jobType$.pipe(
    map((jobType) => {
      if (jobType === 'job-request') {
        return 'job-request';
      } else if (jobType === 'job-series') {
        return 'job-series';
      } else {
        return 'content_paste';
      }
    }),
  );

  tooltip$ = this.icon$.pipe(
    map((icon) => {
      if (icon === 'job-request') {
        return 'jobRequest';
      } else if (icon === 'job-series') {
        return 'jobSeries';
      } else {
        return 'job';
      }
    }),
  );

  constructor() {}
}
